// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'
import {
  assembleQuery,
  fetchContactsByQuery,
} from 'helpers/api'

const NON_SEARCH_FIELDS = new Set([
  'pagination',
])

const fetchData = ({ formValues }) => {
  // we only want to show active contacts in our results
  const search = [{
    field: 'active',
    operator: 'EQ',
    value: true,
  }]

  let hasValue = false

  Object.keys(formValues).forEach(field => {
    if (NON_SEARCH_FIELDS.has(field)) {
      return
    }

    // skip non-string form values (checkbox arrays, etc.)
    if (typeof formValues[field] !== 'string') {
      return
    }

    let value = formValues[field].trim()
    let operator = 'LIKE'

    if (value) {
      hasValue = true

      // users can search for multiple contact codes at a time.
      if (field === 'serviceContactCode' && value.includes(',')) {
        operator = 'IN'
        // delete any whitespace, newlines etc
        value = value.replace(/[\n\r\s\t]+?/g, '')
      }

      search.push({
        value,
        field,
        operator,
      })
    }
  })

  // form must have at least one value
  // throws error message if false
  if (!hasValue) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  const query = [{
    field: 'search',
    value: [search],
  }, {
    field: 'includeGeneralContacts',
    value: false,
  }]

  return fetchContactsByQuery(assembleQuery(query))
}

export default fetchData
